export const enum RouteCore {
  dashboard = 'dashboard',
}
